import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { Admin_Parivartan_Create_Buisness } from "../../../../constants";
import axios from "axios";
import toast from "react-hot-toast";

const AddNewBuisnessModal = ({ open, onClose, onRefresh }) => {
  const [buisnessName, setBuisnessName] = useState("");

  const handleSubmit = async () => {
    const payload = {
      buisnessName: buisnessName,
    };

    try {
      const res = await axios.post(Admin_Parivartan_Create_Buisness, payload);
      if (res.data.success) {
        toast.success("Buisness Created Successfully.");
        onClose();
        onRefresh();
        handleReset();
      } else {
        toast.error(res.data.message || "Failed to create buisness");
      }
    } catch (err) {
      const message =
        err?.response?.data?.message || err?.message || "Something went wrong";
      toast.error(message);
    }
  };

  const handleReset = () => {
    setBuisnessName("");
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
        <DialogTitle>
          <Typography variant="h6" fontWeight="bold">
            Add New Buisness
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={2} mt={1}>
            <TextField
              labelId="buisness-label"
              label="Buisness Name"
              value={buisnessName}
              onChange={(e) => setBuisnessName(e.target.value)}
              size="small"
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={() => {
              onClose();
            }}
            color="error"
          >
            Cancel
          </Button>
          <Button variant="contained" onClick={handleSubmit}>
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AddNewBuisnessModal;
